// libraries.
import styled, { css } from "styled-components";
import {
  electricPurple50,
  electricPurple300,
  electricPurple500,
  monserratSemiBold,
  robotoRegular,
  scarpaGray100,
  scarpaGray200,
  scarpaGray500,
  tomatoCoral500,
  turquoise600,
  white,
} from "@habitech/shared";

export const StyledRulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  .rules-fixed-header {
    flex-shrink: 0;
    padding: 24px 24px 16px 24px;
  }

  .rules-title {
    font-family: ${monserratSemiBold};
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }

  .rules-text,
  p,
  span,
  label {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const StyledExceptionCard = styled.div`
  background-color: ${white};
  border: 1px solid ${scarpaGray200};
  border-radius: 8px;
  padding: 16px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0px 4px 16px rgba(51, 51, 51, 0.08);
  }

  .exception-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: #fff3f3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .exception-title {
    font-family: ${monserratSemiBold};
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #333;
  }

  .exception-description {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${scarpaGray500};
  }

  .exception-badge {
    font-family: ${robotoRegular};
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    background-color: #fff3f3;
    color: ${tomatoCoral500};
  }

  .exception-edit-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 14px;
    opacity: 0.5;
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 1;
      background-color: ${scarpaGray100};
    }
  }
`;

export const StyledColorLegend = styled.div`
  flex-shrink: 0;
  background-color: ${white};
  padding: 12px 0px;

  .legend-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 16px;
    background-color: ${scarpaGray100};
    border-radius: 8px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;

    &.transicion {
      background-color: ${electricPurple500};
    }
    &.bono {
      background-color: ${turquoise600};
    }
    &.descuento {
      background-color: #f59e0b;
    }
    &.remate {
      background-color: ${tomatoCoral500};
    }
  }

  .legend-label {
    font-family: ${robotoRegular};
    font-size: 12px;
    font-weight: 500;
    color: ${scarpaGray500};
  }
`;

export const StyledTimeline = styled.div`
  position: relative;

  .timeline-line {
    position: absolute;
    left: 19px;
    top: 40px;
    bottom: 20px;
    width: 2px;
    background-color: ${scarpaGray200};
  }

  .timeline-step {
    position: relative;
    padding-left: 52px;
    padding-bottom: 24px;
  }

  .timeline-dot {
    position: absolute;
    left: 10px;
    top: 4px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid ${scarpaGray200};
    background-color: ${white};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    &.transicion {
      border-color: ${electricPurple300};
      background-color: ${electricPurple50};
    }
    &.bono {
      border-color: ${turquoise600};
      background-color: #e6faf8;
    }
    &.descuento {
      border-color: #f59e0b;
      background-color: #fffbeb;
    }
    &.remate {
      border-color: ${tomatoCoral500};
      background-color: #fff3f3;
    }
  }

  .timeline-dot-inner {
    width: 8px;
    height: 8px;
    border-radius: 50%;

    &.transicion {
      background-color: ${electricPurple500};
    }
    &.bono {
      background-color: ${turquoise600};
    }
    &.descuento {
      background-color: #f59e0b;
    }
    &.remate {
      background-color: ${tomatoCoral500};
    }
  }

  .step-card {
    background-color: ${white};
    border: 1px solid ${scarpaGray200};
    border-radius: 8px;
    padding: 16px;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0px 4px 16px rgba(51, 51, 51, 0.08);
    }
  }

  .step-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .step-name {
    font-family: ${monserratSemiBold};
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #333;
  }

  .step-badge {
    font-family: ${robotoRegular};
    font-size: 12px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 12px;

    &.transicion {
      background-color: ${electricPurple50};
      color: ${electricPurple500};
    }
    &.bono {
      background-color: #e6faf8;
      color: ${turquoise600};
    }
    &.descuento {
      background-color: #fffbeb;
      color: #b45309;
    }
    &.remate {
      background-color: #fff3f3;
      color: ${tomatoCoral500};
    }
  }

  .step-description {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${scarpaGray500};
    margin-bottom: 8px;
  }

  .step-details {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: ${scarpaGray500};
    background-color: ${scarpaGray100};
    border-radius: 6px;
    padding: 10px 12px;
  }

  .step-day-range {
    font-family: ${robotoRegular};
    font-size: 12px;
    color: ${scarpaGray500};
  }

  .step-modifies {
    font-family: ${robotoRegular};
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;

    &.yes {
      background-color: #e8f0fe;
      color: #1a56db;
    }
    &.no {
      background-color: #f2f2f2;
      color: ${scarpaGray500};
    }
  }

  .step-edit-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 14px;
    opacity: 0.5;
    transition: opacity 0.15s ease;
    flex-shrink: 0;

    &:hover {
      opacity: 1;
      background-color: ${scarpaGray100};
    }
  }
`;

const addItemButtonStyles = css`
  .btn-add-item {
    width: fit-content;
    background: none;
    border: 1.5px dashed ${electricPurple300};
    border-radius: 8px;
    padding: 6px 16px;
    font-size: 12px;
    font-family: ${robotoRegular};
    color: ${electricPurple500};
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
      background-color: ${electricPurple50};
      border-color: ${electricPurple500};
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .btn-remove-item {
    background: none;
    border: 1px solid ${tomatoCoral500};
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 11px;
    font-family: ${robotoRegular};
    color: ${tomatoCoral500};
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover:not(:disabled) {
      background-color: rgba(255, 80, 60, 0.07);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
`;

const badgeStatusStyles = css`
  .badge-status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 12px;
    white-space: nowrap;

    &.active {
      background-color: #e6f9f0;
      color: #12a150;
    }
    &.inactive {
      background-color: ${scarpaGray100};
      color: ${scarpaGray500};
    }
  }
`;

export const StyledRulesModalForm = styled.div`
  ${badgeStatusStyles}
  ${addItemButtonStyles}
  .form-control,
  .form-select {
    font-family: ${robotoRegular};
    font-size: 14px;

    &::placeholder {
      font-family: ${robotoRegular};
      font-size: 14px;
      color: ${scarpaGray500};
      opacity: 0.7;
    }

    &:focus {
      border-color: ${scarpaGray200};
      box-shadow: 0px 4px 16px rgba(51, 51, 51, 0.08);
    }
  }

  .form-label {
    font-family: ${robotoRegular};
    font-size: 13px;
    color: ${scarpaGray500};
    margin-bottom: 4px;
  }

  .form-check-input:checked {
    background-color: ${electricPurple500};
    border-color: ${electricPurple500};
  }

  .form-check-input:focus {
    border-color: ${electricPurple300};
    box-shadow: 0 0 0 2px rgba(99, 1, 204, 0.15);
  }

  .form-check-label {
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray500};
  }
`;

export const StyledSummaryFlow = styled.div`
  width: 100%;
  /* header ≈ 72px + tabs-header ≈ 48px + description ≈ 60px + gaps ≈ 40px */
  height: calc(100vh - 200px);
  min-height: 400px;

  .react-flow__attribution {
    display: none;
  }

  .react-flow__edge-path {
    stroke: ${scarpaGray200};
    stroke-width: 2;
  }

  .react-flow__edge-text {
    font-family: ${robotoRegular};
    font-size: 12px;
    font-weight: 600;
  }

  .react-flow__controls {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .react-flow__minimap {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const StyledRulesTable = styled.div`
  margin-top: 16px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: ${robotoRegular};
    font-size: 13px;
  }

  thead tr {
    border-bottom: 2px solid ${scarpaGray200};
  }

  th {
    font-family: ${monserratSemiBold};
    font-weight: 600;
    font-size: 12px;
    color: ${scarpaGray500};
    padding: 8px 12px;
    text-align: center;
    white-space: nowrap;
  }

  td {
    padding: 10px 12px;
    vertical-align: middle;
    color: #333;
    border-bottom: 1px solid ${scarpaGray100};
  }

  .cell-centered {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  tbody tr:hover td {
    background-color: ${scarpaGray100};
  }

  .cell-name {
    font-family: ${monserratSemiBold};
    font-weight: 600;
    font-size: 13px;
    max-width: 220px;
  }

  .cell-description {
    display: block;
    color: ${scarpaGray500};
    line-height: 1.5;
  }

  ${badgeStatusStyles}

  .badge-type {
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 12px;
    white-space: nowrap;

    &.excepcion {
      background-color: #fff3f3;
      color: ${tomatoCoral500};
    }
    &.transicion {
      background-color: ${electricPurple50};
      color: ${electricPurple500};
    }
    &.bono {
      background-color: #e6faf8;
      color: ${turquoise600};
    }
    &.descuento {
      background-color: #fffbeb;
      color: #b45309;
    }
    &.remate {
      background-color: #fff3f3;
      color: ${tomatoCoral500};
    }
  }

  .action-btn {
    background: none;
    border: 1px solid ${scarpaGray200};
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 12px;
    font-family: ${robotoRegular};
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover:not(:disabled) {
      background-color: ${scarpaGray100};
      border-color: ${scarpaGray500};
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    &.btn-edit {
      color: ${electricPurple500};
      border-color: ${electricPurple500};

      &:hover {
        background-color: ${electricPurple50};
      }
    }

    &.btn-activate {
      color: #12a150;
      border-color: #12a150;
    }

    &.btn-deactivate {
      color: ${scarpaGray500};
      border-color: ${scarpaGray200};
    }
  }
`;

export const StyledTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 0 24px;

  .tabs-header {
    flex-shrink: 0;
    border-bottom: 1px solid ${scarpaGray200};
  }

  .tabs-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: 14px;
  }

  .tabs-loader {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

